import { render, staticRenderFns } from "./quotationCustomerDiscount.vue?vue&type=template&id=907cfa32&scoped=true"
import script from "./quotationCustomerDiscount.vue?vue&type=script&lang=js"
export * from "./quotationCustomerDiscount.vue?vue&type=script&lang=js"
import style0 from "./quotationCustomerDiscount.vue?vue&type=style&index=0&id=907cfa32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907cfa32",
  null
  
)

export default component.exports